import { render, staticRenderFns } from "./OrganizationDashboardTab.vue?vue&type=template&id=527159ea&scoped=true"
import script from "./OrganizationDashboardTab.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationDashboardTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrganizationDashboardTab.vue?vue&type=style&index=0&id=527159ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527159ea",
  null
  
)

export default component.exports